import { jsx } from "react/jsx-runtime";
import React from "react";
import cx from "classnames";
const Divider = ({ baseClass, hidden }) => /* @__PURE__ */ jsx(
  "span",
  {
    className: cx(
      `${baseClass}__divider`,
      hidden && `${baseClass}__divider--hidden`
    ),
    "aria-hidden": "true"
  }
);
export {
  Divider
};
